import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'snakeCase'
})
export class SnakeCasePipe implements PipeTransform {
	transform(_value: any, _args?: unknown): any {
		return null;
	}
}
